import {
  ASSIGNED_TO_SERVICE_PROVIDER,
  COMPLETED,
  DRAFT,
  JobStatus,
  REQUESTED,
  CANCELLED,
} from '@/models/job'
import { useStore } from 'vuex-composition-helpers'
import { computed } from 'vue'

export function useCanJobBeEdited() {
  const store = useStore()
  const canModifyScheduledOrInProgressJob = computed<(hubId: string) => boolean>(
    () => store.getters['permissions/canModifyScheduledOrInProgressJob'],
  )

  const canJobBeEdited = (status: JobStatus, isArchived: boolean, hubId: string) => {
    if (isArchived || [COMPLETED, CANCELLED].includes(status)) {
      return false
    }

    if (![DRAFT, REQUESTED, ASSIGNED_TO_SERVICE_PROVIDER].includes(status)) {
      return canModifyScheduledOrInProgressJob.value(hubId)
    }

    return true
  }

  return canJobBeEdited
}
